import React, { Fragment } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { HomePage } from "./pages/home";
import { ManageBrains } from "./pages/manage-brains";
import { AnimatePresence } from "framer-motion";
import { BrainSetting } from "./pages/brain-setting";
import { Uploadknowledge } from "./pages/uploadknowledge";
import { LoginPage } from "./pages/login";
import { SignUpPage } from "./pages/sign-up";
import { ForgotPassword } from "./pages/forgot-password";
import { Profile } from "./pages/profile";
import { MyAccount } from "./pages/my-account";
import { BrainChat } from "./components/brainChat";
import { KnowledgeChat } from "./components/knowledgeChat";
import { BrowserHomePage } from "./pages/browser-home";
import { PublicChat } from "./pages/public-chat";
import { ErrorPage403 } from "./pages/403";
import { LandingHome } from "./landing_website/landing-home";
import { Terms } from "./landing_website/terms";
import { Logout } from "./pages/logout";
import { Articles } from "./landing_website/articles";
import { ArticleDetail } from "./landing_website/article-detail";
import { DatabaseChat } from "./components/databaseChat";
const RoutesList = () => {
  const location = useLocation();
  return (
    <Fragment>
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<LandingHome />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/browserHome/:id" element={<BrowserHomePage />} />
          <Route path="/brainChat/:id" element={<BrainChat />} />
          <Route path="/knowledgeChat/:id" element={<KnowledgeChat />} />
          <Route path="/databaseChat/:id" element={<DatabaseChat />} />
          <Route path="/share/:id" element={<PublicChat />} />
          <Route path="manage-brains" element={<ManageBrains />} />
          <Route path="brain-setting/:id" element={<BrainSetting />} />
          <Route path="uploadknowledge" element={<Uploadknowledge />} />
          <Route path="my-account" element={<MyAccount />} />
          <Route path="profile" element={<Profile />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="sign-up" element={<SignUpPage />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="/403" element={<ErrorPage403 />} />
          <Route path="landing-home" element={<LandingHome />} />
          <Route path='articles' element={<Articles/>} /> 
          <Route path='article-detail/:id' element={<ArticleDetail/>} />
          <Route path="terms" element={<Terms />} />
          <Route path="logout" element={<Logout />} />
        </Routes>
      </AnimatePresence>
    </Fragment>
  );
};

export default RoutesList;
